"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQuerySourceDereferenceLinkForceSparql = void 0;
const bus_query_source_dereference_link_1 = require("@comunica/bus-query-source-dereference-link");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const readable_stream_1 = require("readable-stream");
/**
 * A comunica Force SPARQL Query Source Hypermedia Resolve Actor.
 */
class ActorQuerySourceDereferenceLinkForceSparql extends bus_query_source_dereference_link_1.ActorQuerySourceDereferenceLink {
    mediatorMetadataAccumulate;
    mediatorQuerySourceIdentifyHypermedia;
    constructor(args) {
        super(args);
        this.mediatorMetadataAccumulate = args.mediatorMetadataAccumulate;
        this.mediatorQuerySourceIdentifyHypermedia = args.mediatorQuerySourceIdentifyHypermedia;
    }
    async test(action) {
        if (action.link.forceSourceType === 'sparql' && action.context.get(context_entries_1.KeysQueryOperation.querySources)?.length === 1) {
            return (0, core_1.passTestVoid)();
        }
        return (0, core_1.failTest)(`${this.name} can only handle a single forced SPARQL source`);
    }
    async run(action) {
        const context = action.link.context ? action.context.merge(action.link.context) : action.context;
        // No need to do metadata extraction if we're querying over just a single SPARQL endpoint.
        const quads = new readable_stream_1.Readable();
        quads._read = () => {
            quads.push(null);
            return null;
        };
        const metadata = (await this.mediatorMetadataAccumulate
            .mediate({ context: action.context, mode: 'initialize' })).metadata;
        // Determine the source
        const { source, dataset } = await this.mediatorQuerySourceIdentifyHypermedia.mediate({
            context,
            forceSourceType: action.link.forceSourceType,
            handledDatasets: action.handledDatasets,
            metadata,
            quads,
            url: action.link.url,
        });
        return { source, metadata: metadata, dataset };
    }
}
exports.ActorQuerySourceDereferenceLinkForceSparql = ActorQuerySourceDereferenceLinkForceSparql;
//# sourceMappingURL=ActorQuerySourceDereferenceLinkForceSparql.js.map